module.exports = __webpack_public_path__ + "img/switch_off.84fde512.svg";